/**
 * Beyza Fashion header & footer helpers.
 * - Announcement bar close button (remembered for the browser session)
 * - Auto-submit for the footer country/language selectors
 *
 * Menus, drawers, search, account and cart are still handled by Fabric's own scripts.
 */

const STORAGE_PREFIX = 'beyza-announcement-closed-';

/**
 * Recalculate the header offsets after the announcement bar is hidden.
 * Fabric only measures these once on page load (layout/theme.liquid), so we repeat the
 * same calculation here instead of relying on a resize event, avoiding a gap above the sticky header.
 */
function refreshHeaderHeights() {
  const header = document.querySelector('header-component');
  const headerGroup = document.querySelector('#header-group');
  if (header && headerGroup) {
    let groupHeight = 0;
    for (const element of Array.from(headerGroup.children)) {
      if (element === header || !(element instanceof HTMLElement)) continue;
      groupHeight += element.offsetHeight;
    }
    if (header.hasAttribute('transparent') && header.parentElement?.nextElementSibling) {
      groupHeight += header.offsetHeight;
    }
    document.body.style.setProperty('--header-height', `${header.offsetHeight}px`);
    document.body.style.setProperty('--header-group-height', `${groupHeight}px`);
  }
  window.dispatchEvent(new Event('resize'));
}

function initAnnouncementClose() {
  document.querySelectorAll('[data-beyza-announcement-close]').forEach((button) => {
    if (!(button instanceof HTMLButtonElement) || button.dataset.beyzaBound === 'true') return;
    button.dataset.beyzaBound = 'true';

    button.addEventListener('click', () => {
      const sectionId = button.dataset.sectionId;
      const wrapper = button.closest('.shopify-section') ?? button.closest('aside');
      if (!wrapper) return;

      wrapper.classList.add('beyza-announcement--closed');

      try {
        if (sectionId) sessionStorage.setItem(`${STORAGE_PREFIX}${sectionId}`, '1');
      } catch (error) {
        // Storage can be unavailable (private mode); closing still works for this page view.
      }

      refreshHeaderHeights();
    });
  });
}

function initLocalizationAutosubmit() {
  document.querySelectorAll('select[data-beyza-autosubmit]').forEach((select) => {
    if (!(select instanceof HTMLSelectElement) || select.dataset.beyzaBound === 'true') return;
    select.dataset.beyzaBound = 'true';

    select.addEventListener('change', () => {
      const form = select.form;
      if (!form) return;

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  });
}

function init() {
  initAnnouncementClose();
  initLocalizationAutosubmit();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}

// Re-bind when sections are re-rendered in the theme editor.
document.addEventListener('shopify:section:load', init);
